import React from 'react';
import { Dialog } from '@mui/material';
import ConsentPrompContent from './ConsentPrompContent';

interface Props {
  isConsentDeclinedSuppression?: boolean;
  shouldUseUnifiedConsent?: boolean;
  onAccept: () => void;
  onReject: () => void;
  open: boolean;
  privacyPolicyName?: string;
}

const ConsentPrompDialog: React.FC<Props> = (props: Props): JSX.Element => {
  const { open, ...ConsentPrompContentProps } = props;

  return (
    <Dialog disableEscapeKeyDown maxWidth="sm" open={open}>
      <ConsentPrompContent {...ConsentPrompContentProps} />
    </Dialog>
  );
};

export default ConsentPrompDialog;
